import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import Logo from '../assets/images/Logo_blue_2x.svg';
import DemoToggle from '../components/DemoToggle';
import HomeIcon from '../components/svg/HomeIcon';
import CurrencyIcon from '../components/svg/CurrencyIcon';
import ClockCounterIcon from '../components/svg/ClockCounterIcon';
import RewardsIcon from '../components/svg/RewardsIcon';
import QuestionIcon from '../components/svg/QuestionIcon';
import BlockchainIcon from '../components/svg/BlockchainIcon';

import ArrowIcon from '../assets/images/arrowsInLineHorizontal.svg';

const SendIcon = ({ size = 'w-5 h-5', color = '#181D27' }) => (
  <svg className={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 2L11 13" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const InvestmentsIcon = ({ size = 'w-5 h-5', color = '#181D27' }) => (
  <svg className={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 3v18h18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 14l4-4 4 4 5-7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const BookIcon = ({ size = 'w-5 h-5', color = '#181D27' }) => (
  <svg className={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const sidebarData = [
  {
    title: 'Inicio',
    icon: (size, color) => <HomeIcon size={size} color={color} />,
    alt: 'Home Icon',
    path: '/dashboard',
  },
  {
    title: 'Enviar',
    icon: (size, color) => <SendIcon size={size} color={color} />,
    alt: 'Send Icon',
    path: '/dashboard/transfer',
  },
  {
    title: 'Cuentas Globales',
    icon: (size, color) => <CurrencyIcon size={size} color={color} />,
    alt: 'Global Accounts Icon',
    path: '/dashboard/accounts',
  },
  {
    title: 'Mi Cartera',
    icon: (size, color) => <BlockchainIcon size={size} color={color} />,
    alt: 'Wallet Icon',
    path: '/dashboard/assets',
  },
  {
    title: 'Invertir',
    icon: (size, color) => <InvestmentsIcon size={size} color={color} />,
    alt: 'Invest Icon',
    path: '/dashboard/investments',
  },
  {
    title: 'Generar Rendimiento',
    icon: (size, color) => <RewardsIcon size={size} color={color} />,
    alt: 'Yield Icon',
    path: '/dashboard/rewards',
  },
  {
    title: 'Glosario',
    icon: (size, color) => <BookIcon size={size} color={color} />,
    alt: 'Glossary Icon',
    path: '/dashboard/glosario',
  },
  {
    title: 'Historial',
    icon: (size, color) => <ClockCounterIcon size={size} color={color} />,
    alt: 'History Icon',
    path: '/dashboard/history',
  },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState('/');

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location.pathname]);

  const onChangeRoute = (path) => {
    setActiveTab(path);
    navigate(path);
  };

  return (
    <div className="w-65 h-screen bg-white border-r border-r-1 border-r-[#F5F5F5] p-6 flex flex-col justify-between">
      <div className="space-y-8">
        <DemoToggle>
          <div className="w-[155px] h-17">
            <img src={Logo} alt="App logo" />
          </div>
        </DemoToggle>
        <ul className="space-y-1">
          {sidebarData.map((data, idx) => (
            <li
              key={idx}
              onClick={() => onChangeRoute(data.path)}
              className={`px-4 py-3 w-52 rounded-[12px] cursor-pointer hover:bg-[#E6EBF7] flex items-center justify-center space-x-1 text-[#2A59C6] ${
                activeTab == data.path ? 'bg-[#E6EBF7]' : ''
              }`}
            >
              {data.icon('w-5 h-5', activeTab == data.path ? '#2A59C6' : '#181D27')}
              <p
                className={`w-full text-sm leading-[20px] tracking-[0%] ${
                  activeTab == data.path
                    ? 'text-[#2A59C6] font-semibold'
                    : 'text-[#181D27] font-normal'
                }`}
              >
                {data.title}
              </p>
            </li>
          ))}
        </ul>
      </div>

      <div className="border-t-1 border-t-[#D5D7DA]">
        <button
          onClick={() => onChangeRoute('/dashboard/contact')}
          className={`p-4 py-3 w-52 cursor-pointer hover:bg-[#E6EBF7] flex items-center justify-center space-x-1 ${
            activeTab == '/contact' ? 'bg-[#E6EBF7]' : ''
          }`}
        >
          <QuestionIcon color={activeTab == '/dashboard/contact' ? '#2A59C6' : '#181D27'} />
          <p
            className={`w-full text-sm font-normal leading-[20px] tracking-[0%] text-left ${
              activeTab == '/contact'
                ? 'text-[#2A59C6] font-semibold'
                : 'text-[#181D27] font-normal'
            }`}
          >
            Ayuda
          </p>
        </button>
        <button className="p-4 py-3 w-52 cursor-pointer hover:bg-[#E6EBF7] flex items-center justify-center space-x-1">
          <img src={ArrowIcon} alt="Arrow Icon" className="w-5 h-5" />
          <p className="w-full text-sm font-normal leading-[20px] tracking-[0%] text-[#181D27] text-left">
            Colapsar
          </p>
        </button>
      </div>
    </div>
  );
}
